import $ from './jquery-shim.js';

/**
 * 店通関連クラス
 */
export default class Tentsu {
  constructor() {
    this.setPost();
  }

  /**
   * 投稿（最新5件）設定
   */
  async setLatestPosts() {
    const el = $('.js-tentsu-slider .c-tentsu__slider-wrap');
    const posts = await this.fetchLatestPosts();
    await this.setLatestElement(el, posts);
  }

  /**
   * 投稿（単体）設定
   */
  setPost() {
    const self = this;
    $('.js-tentsu-interview-post').each(async function () {
      const el = $(this);
      const id = el.data('id');
      const post = await self.fetchPost(id);
      await self.setInterviewElement(el, post);
      await el.removeClass('is-loding');
    });
    $('.js-tentsu-related-post').each(async function () {
      const el = $(this);
      const id = el.data('id');
      const post = await self.fetchPost(id);
      await self.setRelatedElement(el, post);
      await el.removeClass('is-loding');
    });
  }

  /**
   * 投稿（最新5件）取得
   * @returns {Array}
   */
  async fetchLatestPosts() {
    const self = this;
    let posts = [];
    await fetch('https://www.tenpo.biz/tentsu/wp-json/wp/v2/posts?_embed&per_page=5')
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        json.forEach(function (post) {
          let thumbUrl = 'https://www.tenpo.biz/tentsu/wp-content/themes/tentsu/assets/images/common/thumb-none.webp';
          if ('media_details' in post['_embedded']['wp:featuredmedia'][0]) {
            thumbUrl = post['_embedded']['wp:featuredmedia'][0]['media_details']['sizes']['thumbnail']['source_url'];
          }
          let postAry = {
            id: post['id'],
            url: post['link'],
            thumbUrl: thumbUrl,
            date: self.formatTimestamp(post['date']),
            categoryName: self.getParentTerm(post['_embedded']['wp:term'][0], 'name'),
            categorySlug: self.getParentTerm(post['_embedded']['wp:term'][0], 'slug'),
            title: post['title']['rendered'],
          };
          posts.push(postAry);
        })
      })
      .catch(function (error) {
        console.error('Error:', error);
      });
    return posts;
  }

  /**
   * 投稿（単体）取得
   * @param {Number} postId
   * @returns {Array}
   */
  async fetchPost(postId){
    const self = this;
    let post = {};
    await fetch('https://www.tenpo.biz/tentsu/wp-json/wp/v2/posts/' + postId + '?_embed')
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        let thumbUrl = 'https://www.tenpo.biz/tentsu/wp-content/themes/tentsu/assets/images/common/thumb-none.webp';
        if ('media_details' in json['_embedded']['wp:featuredmedia'][0]) {
          thumbUrl = json['_embedded']['wp:featuredmedia'][0]['media_details']['sizes']['thumbnail']['source_url'];
        }
        post = {
          id: json['id'],
          url: json['link'],
          thumbUrl: thumbUrl,
          date: self.formatTimestamp(json['date']),
          categoryName: self.getParentTerm(json['_embedded']['wp:term'][0], 'name'),
          categorySlug: self.getParentTerm(json['_embedded']['wp:term'][0], 'slug'),
          title: json['title']['rendered'],
        };
      })
      .catch(function (error) {
        console.error('Error:', error);
      });
    return post;
  }

  /**
   * 最新5件 配置
   * @param {*} el
   * @param {Array} posts
   */
  async setLatestElement(el, posts) {
    const self = this;
    let html = '';
    posts.forEach(function(post){
      const color = self.getCategoryColor(post['categorySlug']);
      html += `
				<div class="swiper-slide c-tentsu__item">
					<a href="${post['url']}" target="_blank" rel="noopener" class="c-tentsu__item-link">
						<div class="c-tentsu__item-thumb"><img src="${post['thumbUrl']}" alt=""></div>
						<div class="c-tentsu__item-contents">
							<div class="c-tentsu__item-status">
								<div class="c-tentsu__item-date">${post['date']}</div>
								<div class="c-tentsu__item-category is-${color}">${post['categoryName']}</div>
							</div>
							<h3 class="c-tentsu__item-title">${post['title']}</h3>
						</div>
					</a>
				</div>
      `;
    });
    await el.html(html);
  }

  /**
   * 社員インタビュー投稿 配置
   * @param {*} el
   * @param {Array} post
   */
  setInterviewElement(el, post) {
    const color = this.getCategoryColor(post['categorySlug']);
    const html = `<a href="${post['url']}" target="_blank" rel="noopener" class="c-interviews-post__item-link">
        <div class="c-interviews-post__item-thumb">
          <img src="${post['thumbUrl']}" alt="" width="366" height="223">
        </div>
        <div class="c-interviews-post__item-status">
          <div class="c-interviews-post__item-date">${post['date']}</div>
          <div class="c-interviews-post__item-category is-${color}">${post['categoryName']}</div>
        </div>
        <h3 class="c-interviews-post__item-title">${post['title']}</h3>
      </a>
    `;
    el.html(html);
  }

  /**
   * 関連投稿 配置
   * @param {*} el
   * @param {Array} post
   */
  setRelatedElement(el, post) {
    const color = this.getCategoryColor(post['categorySlug']);
    const html = `<a href="${post['url']}" target="_blank" rel="noopener" class="c-related-articles__item-link">
					<div class="c-related-articles__item-thumb">
            <img src="${post['thumbUrl']}" alt="" width="413" height="252">
          </div>
					<div class="c-related-articles__item-contents">
						<div class="c-related-articles__item-status">
							<div class="c-related-articles__item-date">${post['date']}</div>
							<div class="c-related-articles__item-category is-${color}">${post['categoryName']}</div>
						</div>
						<h3 class="c-related-articles__item-title">${post['title']}</h3>
					</div>
				</a>
    `;
    el.html(html);
  }

  /**
   * 日付フォーマッター
   * @param {String} dateRaw
   * @returns
   */
  formatTimestamp(dateRaw) {
    return new Date(dateRaw).toLocaleDateString('ja-JP', {
      year: 'numeric', month: '2-digit',
      day: '2-digit'
    }).replaceAll('/', '.');
  }

  /**
   * 大カテゴリー取得
   * @param {Array} terms
   * @param {String} type
   * @returns
   */
  getParentTerm(terms, type) {
    let parentTerm = terms.find(function (value) {
      return !value['_links']['up'];
    });
    switch (type) {
      case 'name':
        return parentTerm['name']
        break;
      case 'slug':
        return parentTerm['slug']
        break;
    }
  }

  /**
   * カテゴリーカラー取得
   * @param {Strgin} slug
   * @returns
   */
  getCategoryColor(slug){
    const slugList = {
      organization: 'red',
      worker: 'turquoise',
      business: 'blue',
      culture: 'purple',
      information: 'yellow'
    }
    return slugList[slug];
  }
}
